import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserMessagesService } from './shared/user-messages/user-messages.service';
@Component({
    moduleId: module.id,
    templateUrl: './page-not-found.component.html',

})

export class PageNotFoundComponent implements OnInit, OnDestroy 
{
    constructor(private userMessagesService: UserMessagesService){}

    ngOnInit()
    {
        this.userMessagesService.setErrorMessage("הדף המבוקש לא נמצא אנא נסו שנית");
    }

    ngOnDestroy()
    {
        this.userMessagesService.clearAll();
    }
}
